import { setQueryString, getQueryString } from '@/utils/UrlUtils';

const INITIAL_STATE = {
  details: {},
  refData: {},
  currentPage: 1,
  formNotValid: false,
  hasFormBeenUpdated: false,
  submitUpdateSuccessful: false,
  submitPolicyInProcess: false,
};

export default {
  namespaced: true,

  state: { ...INITIAL_STATE },

  mutations: {
    /**
     *
     */
    resetPaymentDetails(state, resetSubmitUpdateSuccessful = true) {
      const resettedState = { ...INITIAL_STATE };

      if (!resetSubmitUpdateSuccessful) {
        resettedState.submitUpdateSuccessful = state.submitUpdateSuccessful;
      }

      Object.assign(state, resettedState);
    },

    updatePaymentDetailsRefData(state, data) {
      state.refData = data;
    },

    updatePaymentDetailsInfo(state, data) {
      state.details = data;
    },

    updatePaymentDetailsPageNum(state, pageNum) {
      state.currentPage = pageNum;

      if (Number(getQueryString('step')) !== Number(pageNum)) {
        setQueryString('step', pageNum);
      }
    },

    updatePaymentDetailsFormValid(state, data) {
      state.formNotValid = data;
    },

    updateHasFormBeenUpdated(state, data) {
      state.hasFormBeenUpdated = data;
    },

    updateSubmitUpdateSuccessful(state, data) {
      state.submitUpdateSuccessful = data;
    },

    updateSubmitPolicyInProcess(state, data) {
      state.submitPolicyInProcess = data;
    },
  },

  getters: {
    getSubmitUpdateSuccessfulStatus: (state) => {
      return state.submitUpdateSuccessful;
    },

    getPaymentDetailsFormValidationStatus: (state) => {
      return state.formNotValid;
    },

    getPaymentDetailsPageReferenceData: (state) => {
      return state.refData;
    },

    getPaymentDetails: (state) => {
      return state.details;
    },

    getPaymentDetailsPageNum: (state) => {
      return state.currentPage;
    },

    getHasFormBeenUpdated: (state) => {
      return state.hasFormBeenUpdated;
    },

    getSubmitPolicyInProcess: (state) => {
      return state.submitPolicyInProcess;
    },
  },
};
